import env from '@/core/env'
import { createDevelopmentToken } from '@/core/services/admin-service'
import { storeToken, token } from '@/core/services/auth-service'
import { getAppConfiguration } from '@/core/services/configuration-service'
import { loadRequest } from '@/core/services/request-service'
import { onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export default function useAppInitialization(params: { developmentWorkOrderId: string }) {
  const route = useRoute()
  const router = useRouter()

  async function initialize() {
    await getAppConfiguration()
    if(token.value && route.path === '/') {
      await loadRequest()
    }
  }

  onMounted(async () => {
    await router.isReady()
    const queryToken = route.query.token as string
    if(env.isDevelopment && !queryToken && !token.value) {
      await createDevelopmentToken(params.developmentWorkOrderId)
    } else if (queryToken) {
      storeToken(queryToken)
      router.replace({ query: {} })
    }
    await initialize()
  })
}
